"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageBody = void 0;
var _ = require("../..");
var domain = window.location.hostname;
var getMessageBody = exports.getMessageBody = function getMessageBody(camera) {
  var isCamera = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  switch (camera) {
    case _.NO_DEVICE_FOUND:
      return "Check that your ".concat(isCamera ? 'camera' : 'microphone', " is connected and turned on.");
    case _.PERMISSION_DENIED:
      return "Check your browser privacy settings allow ".concat(domain, " access to your ").concat(isCamera ? 'camera' : 'microphone', ".");
    default:
      return null;
  }
};